import { Fragment } from "react";
import { mergeTagCategories, mergeTags } from "../../utils/mergeTags";
import classes from "./List.module.css";

const Liststructure = (props) => {
  const showMergeTags = (categoryId) => {
    const tags = mergeTags.map((tag) => {
      let availableTgs;
      if (tag.category === categoryId) {
        availableTgs = (
          <li
            className={classes.liItems}
            data-mergetag={tag.id}
            key={tag.id}
            onClick={props.mergeTagHandler}
          >
            {tag.label}
          </li>
        );
      }
      return availableTgs;
    });

    return tags;
  };

  const showCategories = () => {
    let tagsAvailable = false;
    const filteredCategories = mergeTagCategories.map((category) => {
      let availableCategories;
      if (category.includedTriggers.indexOf(props.trigger) !== -1) {
        tagsAvailable = true;

        availableCategories = (
          <Fragment key={category.id}>
            <li className={classes.groupHeader}>{category.label}</li>
            {showMergeTags(category.id)}
          </Fragment>
        );
      }
      return availableCategories;
    });
    const emptyDiv = () => {
      return (
        <li className={classes.groupHeader}>
          <div> No Tags Available</div>
        </li>
      );
    };

    return tagsAvailable === true ? filteredCategories : emptyDiv();
  };

  return <ul className={classes.list}>{showCategories()}</ul>;
};

export default Liststructure;
